document.addEventListener('DOMContentLoaded', () => {  
    const readMoreButtons = document.querySelectorAll('.show-more');  
    const contents = document.querySelectorAll('.brand-navigation--content');  

    readMoreButtons.forEach((button, index) => {  
        button.addEventListener('click', () => {  
            const contentItem = contents[index];  

            if (contentItem.classList.contains('expanded')) {  
                contentItem.classList.remove('expanded');  
                button.textContent = "Show more";  
            } else {  
                contentItem.classList.add('expanded');  
                button.textContent = 'Show less';  
            }  
        });  
    });  
});